import {
  SELF_ONBOARDING_ACCESS_ROUTES,
  SELF_ONBOARDING_PATHS,
} from "src/consts/Routes/SelfOnboarding";
import { Box, Stack } from "@mui/material";
import { useLocation } from "react-router-dom";
import PageTitle from "../../../Displays/PageTitle";
import PageSubTitle from "../../../Displays/PageSubTitle";
import VerticalLinearProgress from "../../VerticalLinearProgressBar";

export const progressBarCalculator = (pathname: string) => {
  switch (pathname) {
    case SELF_ONBOARDING_PATHS.ACCESS_SUCCESS:
      return 55;
    case SELF_ONBOARDING_PATHS.ACCESS_FAILED:
      return 55;
    default:
      return 0;
  }
};

const SelfOnboardingAccessProgressBar = () => {
  const { pathname } = useLocation();

  return (
    <Stack
      gap="13px"
      sx={{
        display: { xs: "none", sm: "flex" },
      }}
    >
      <PageTitle text={"Menü"} />
      {SELF_ONBOARDING_ACCESS_ROUTES.includes(pathname) && (
        <Box
          sx={{
            gap: 3,
            height: 55,
            display: { xs: "flex", sm: "default" },
          }}
        >
          <VerticalLinearProgress
            variant="determinate"
            value={55 - progressBarCalculator(pathname)}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            <PageSubTitle text={"Hardware Zugriff"} />
            <PageSubTitle text={"Status"} />
          </Box>
        </Box>
      )}
    </Stack>
  );
};

export default SelfOnboardingAccessProgressBar;
